import { render, staticRenderFns } from "./AuditView.vue?vue&type=template&id=2c4f0709"
import script from "./AuditView.vue?vue&type=script&lang=js"
export * from "./AuditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports